import 'react-app-polyfill/ie11';
import 'core-js/fn/array/find';
import 'core-js/fn/array/from';
import 'core-js/fn/array/map';
import 'core-js/fn/array/includes';
import 'core-js/fn/object/values';
import 'core-js/fn/object/keys';
import 'core-js/fn/promise';
import 'core-js/fn/set';
import 'core-js/fn/number/is-nan';
import 'core-js/fn/string/pad-start';
import React from 'react';
import './index.css';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import store from './store';
import App from './App';
import { config } from '@fortawesome/fontawesome-svg-core';
import 'react-toastify/dist/ReactToastify.css';
import MaintenancePage from './common/MaintenancePage';

// Make sure this is before any other `fontawesome` API calls
config.autoAddCss = false;

const DefaultTheme = React.lazy(() => import('./themes/DefaultTheme'));
const EpcoTheme = React.lazy(() => import('./themes/EpcoTheme'));
const UrbanTheme = React.lazy(() => import('./themes/UrbanTheme'));
const RecTheme = React.lazy(() => import('./themes/RecTheme'));
const EltecTheme = React.lazy(() => import('./themes/EltecTheme'));
let isUnderMaintenance = window.location.hostname === 'payments.schindler.com';
const ThemeSelector = ({ children }) => {
    console.log(window.location.hostname);
    const getTheme = () => {
    if(window.location.hostname === "theme1.epaylocal" || window.location.hostname === "payments.schindler.com" || window.location.hostname === "payments-qa.schindler.com") return <DefaultTheme />;
    if(window.location.hostname === "theme1.epaylocal" || window.location.hostname === "payments.adamselevator.com" || window.location.hostname === "payments-qa.adamselevator.com") return <DefaultTheme />;
    if(window.location.hostname === "theme2.epaylocal" || window.location.hostname === "payments.epco.us" || window.location.hostname === "payments-qa.epco.us") return <EpcoTheme />;
    if(window.location.hostname === "theme3.epaylocal" || window.location.hostname === "payments.republicelevator.com" || window.location.hostname === "payments-qa.republicelevator.com") return <RecTheme />;
      if (window.location.hostname === "theme4.epaylocal" || window.location.hostname === "payments.suburbanelevator.com" || window.location.hostname === "payments-qa.suburbanelevator.com") return <UrbanTheme />;
      if (window.location.hostname === "theme5.epaylocal" || window.location.hostname === "payments.eltec.cc" || window.location.hostname === "payments-qa.eltec.cc") return <EltecTheme />;
    return <DefaultTheme />
  }; 
  
  // const CHOSEN_THEME = localStorage.getItem('TYPE_OF_THEME') || TYPE_OF_THEME.DEFAULT;
  return (
    <>
      <React.Suspense fallback={<></>}>
        {getTheme()}
      </React.Suspense>
      {children}
    </>
  )
}

export const Index = () => (
    <ThemeSelector>
        <Provider store={store}>
            <App />
        </Provider>
    </ThemeSelector>
);

ReactDOM.render(<Index />, document.getElementById('root'));
